import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        meta: {
            index: 1,
            keepAlive: false // 需要缓存
        },
        component: () => import( '@/views/Login')
    },
    {
        path: '/index',
        name: 'Index',
        meta: {
            index: 2,
            keepAlive: false // 需要缓存
        },
        component: () => import( '@/views/index/index'),
    },
    {
        path: '/lotto',
        name: 'Lotto',
        meta: {
            index: 3,
            keepAlive: false // 需要缓存
        },
        component: () => import( '@/views/lotto/index'),
    },

    {
        path: '/role',
        name: 'Role',
        meta: {
            index: 4,
            keepAlive: true // 需要缓存
        },
        component: () => import( '@/views/Role')
    },
    {
        path: '/prize',
        name: 'Prize',
        meta: {
            index: 5,
            keepAlive: true // 需要缓存
        },
        component: () => import( '@/views/PrizePage')
    },
    {
        path: '/help',
        name: 'Help',
        meta: {
            index: 6,
            keepAlive: true // 需要缓存
        },
        component: () => import( '@/views/Help')
    },
    {
        path: '/fileUpload',
        name: 'FileUpload',
        meta: {
            index: 6,
            keepAlive: true // 需要缓存
        },
        component: () => import( '@/views/upload/FileUploadPage')
    },
]

const router = new VueRouter({
    mode: 'hash',
    routes
})
router.beforeEach((to, from, next) => {
    if (from.path === '/index') {
        if (to.path === '/login' || to.path === '/lotto') {
            next(from.path)
        }
    } else {
        if (from.path !== '/' && to.path === '/login') {
            next(from.path)
        } else {
            next()
        }
    }

    // next()
});
export default router
